import { Component, input } from '@angular/core';
import { Image } from '@frontend/core';

@Component({
  selector: 'multisite-media-statistic-card',
  templateUrl: './media-statistic-card.component.html',
  styleUrl: './media-statistic-card.component.scss',

  standalone: false,
})
export class MediaStatisticCardComponent {

  statistic = input<string>('');
  statisticClasses = input<string>('h1');
  image = input<Image | undefined >(undefined);
  imageClasses = input<string>('');
  imageTransformations = input<string >('w_150,c_fill,ar_1:1/');
  titleText = input<string>('');
  titleTranslationKey = input<string>('');
  titleClasses = input<string>('h5');
  descriptionText = input<string>('');
  descriptionTranslationKey = input<string>('');

}
